import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import Card from "./ui/Card";

const StateHistoryChart = ({ stateSigla, isMobile = false }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/comex/state-history/${stateSigla}`);
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (error) {
        console.error("Erro ao carregar histórico do estado", error);
      } finally {
        setLoading(false);
      }
    };

    if (stateSigla) {
      fetchData();
    }
  }, [stateSigla]);

  if (loading)
    return (
      <Card>
        <div className="text-center py-8 text-[var(--muted)]">
          📈 Carregando histórico...
        </div>
      </Card>
    );

  const formatBillions = (value) => `$${value.toFixed(1)}B`;

  return (
    <Card
      title={`Evolução do Comércio Exterior - ${stateSigla.toUpperCase()}`}
      subtitle={!isMobile ? "Comparativo anual de Exportações e Importações (USD FOB)" : undefined}
    >
      <div style={{ width: "100%", height: isMobile ? 280 : 400 }}>
        <ResponsiveContainer width="99%" height="100%" debounce={50}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
            <XAxis
              dataKey="ano"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#7f8c8d', fontSize: isMobile ? 10 : 12 }}
              interval={isMobile ? "preserveStartEnd" : 0}
            />
            <YAxis
              tickFormatter={formatBillions}
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#7f8c8d', fontSize: isMobile ? 10 : 12 }}
              width={isMobile ? 50 : 60}
            />
            <Tooltip
              formatter={(value, name) => [formatBillions(value), name]}
              contentStyle={{
                borderRadius: '10px',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                fontSize: isMobile ? '0.8rem' : '0.9rem'
              }}
            />
            <Legend
              verticalAlign="top"
              align={isMobile ? "center" : "right"}
              iconType="circle"
              wrapperStyle={{ fontSize: isMobile ? '0.75rem' : '0.9rem' }}
            />

            {/* LINHA 1: EXPORTAÇÕES (Verde) */}
            <Line
              type="monotone"
              dataKey="Exportações"
              stroke="#27ae60"
              strokeWidth={isMobile ? 2 : 3}
              dot={{ r: isMobile ? 3 : 4, strokeWidth: 2, fill: "#fff" }}
              activeDot={{ r: isMobile ? 5 : 6 }}
              name="Exportações"
            />

            {/* LINHA 2: IMPORTAÇÕES (Laranja) */}
            <Line
              type="monotone"
              dataKey="Importações"
              stroke="#e67e22"
              strokeWidth={isMobile ? 2 : 3}
              dot={{ r: isMobile ? 3 : 4, strokeWidth: 2, fill: "#fff" }}
              activeDot={{ r: isMobile ? 5 : 6 }}
              name="Importações"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default StateHistoryChart;
